export const statuses = [
  { id: 'aberto', nome: 'Aberto' },
  { id: 'diagnostico', nome: 'Em diagnóstico' },
  { id: 'orcamento', nome: 'Aguardando aprovação' },
  { id: 'peca', nome: 'Aguardando peça' },
  { id: 'reparo', nome: 'Em reparo' },
  { id: 'pronto', nome: 'Pronto para retirada' },
  { id: 'entregue', nome: 'Entregue' },
];
export const priorities = { urgente: 'Urgente', normal: 'Normal', baixa: 'Baixa' };
export const fields = [
  { key: 'cliente', label: 'Cliente', required: true, lookup: 'clientes', id: 'cliente_id' },
  { key: 'telefone', label: 'Telefone', max: 30, type: 'tel' },
  { key: 'tipo', label: 'Produto', required: true, lookup: 'produtos', id: 'produto_id' },
  { key: 'modelo', label: 'Marca e modelo', max: 80 },
  { key: 'serie', label: 'Nº de série', max: 60 },
  { key: 'tecnico', label: 'Técnico responsável', max: 60, list: 'ast-tecnicos' },
];
export const emptyTicket = () => ({
  cliente: '', cliente_id: '', produto_id: '', telefone: '', tipo: '', modelo: '', serie: '', tecnico: '',
  defeito: '', prioridade: 'normal', valor: '', garantia: false,
});
export function days(ticket) {
  const end = ticket.status === 'entregue' ? ticket.entregueEm : Date.now();
  return Math.max(0, Math.floor((new Date(end || ticket.atualizadoEm).getTime() - new Date(ticket.criadoEm).getTime()) / 86400000)) || 0;
}
export const date = value => (value ? new Date(value).toLocaleString('pt-BR') : 'Não informado');
export const money = value => (value === null || value === '' || value === undefined
  ? 'Não informado' : Number(value).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }));